import React from "react";
import { withRouter } from "@/helpers/router";
import PropTypes from "prop-types";
import { Tag } from "antd";
import { omit, pick } from "lodash";

const AppliedFilters = ({
  fieldSelector,
  fieldMapper,
  valueMapper = (qs, value) => value,
  omitQueryString = ["sort"],
  defaultQuery,
  tagColor,
  title = "Applied Filters",
  nonClosable = [],
  clearButtonText = "Clear All",
  router
}) => {
  const qAll = fieldSelector(router.location.query); // don't show `sort` as a tag, already shown in table header
  const q = omit(qAll, omitQueryString);
  const qOmitted = pick(qAll, omitQueryString);
  const pathname = router.location.pathname;
  const keys = Object.keys(q);
  return keys.length ? (
    <div style={{ width: "100%", margin: 8 }}>
      <b>{`${title}: `}</b>
      {keys.map((k, i) => {
        const valueText = `${valueMapper(k, q[k])}`;
        return (
          <Tag
            variant="outlined"
            closable={nonClosable.indexOf(k) < 0}
            color={tagColor}
            onClose={() => router.push({ pathname, query: { ...omit(qAll, k) } })}
            key={k + i}
          >
            <b>{`${fieldMapper(k)}: `}</b>
            {valueText.length > 50 ? `${valueText.substring(0, 50)}...` : valueText}
          </Tag>
        );
      })}
      <Tag
        variant="outlined"
        style={{ cursor: "pointer" }}
        onClick={() => router.push({ pathname, query: defaultQuery ? defaultQuery : qOmitted })}
      >
        {`${clearButtonText}`}
      </Tag>
    </div>
  ) : null;
};

AppliedFilters.propTypes = {
  fieldSelector: PropTypes.func.isRequired,
  fieldMapper: PropTypes.func.isRequired,
  valueMapper: PropTypes.func,
  omitQueryString: PropTypes.array,
  defaultQuery: PropTypes.object,
  tagColor: PropTypes.string,
  title: PropTypes.string,
  nonClosable: PropTypes.array,
  clearButtonText: PropTypes.string
};
export default withRouter(AppliedFilters);
